import { useQuery } from 'react-query'

import { scanService } from 'src/services/scan.service'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'

export const useScanCreateInitValues = (params?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.SCAN_CREATE_INITIAL, params],
    () => scanService.getCreateScanInitialValues(params),
    {
      enabled: !!params,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}
